import { Link } from "react-router-dom";
import { PenTool, Layers, Users, BarChart3, ArrowLeft } from "lucide-react";

export default function ExamDesignDevelopment() {
    return (
        <main className="min-h-screen bg-gradient-to-b from-indigo-700 via-indigo-600 to-violet-600 px-6 py-12 flex justify-center">
            <div className="w-full max-w-5xl bg-white rounded-2xl shadow-xl p-8">
                <div className="flex items-center gap-3 mb-6">
                    <img src="/Images/ExamsPro.png" alt="ExamsPro" className="w-10 h-10" />
                    <h1 className="text-2xl font-bold text-indigo-700">
                        Exam Design & Development
                    </h1>
                </div>

                <p className="text-gray-600 mb-8 leading-relaxed">
                    Partner with our psychometric and technology teams to build valid,
                    secure, and engaging exams�aligned to your organization�s objectives.
                </p>

                <section className="grid md:grid-cols-2 gap-6">
                    <div className="rounded-xl border border-indigo-100 p-6 hover:shadow-md transition">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <PenTool className="w-5 h-5" />
                            <h3 className="font-semibold">Item Writing & Review</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� Blueprint-based item authoring</li>
                            <li>� Peer and SME review workflows</li>
                            <li>� AI-assisted draft generation (optional)</li>
                        </ul>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6 hover:shadow-md transition">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <Layers className="w-5 h-5" />
                            <h3 className="font-semibold">Bank & Form Management</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� Categorize by domain, objective, or difficulty</li>
                            <li>� Version tracking & cloning</li>
                            <li>� Multiple form assembly and randomization</li>
                        </ul>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6 hover:shadow-md transition">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <Users className="w-5 h-5" />
                            <h3 className="font-semibold">Expert Collaboration</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� SME dashboards and reviewer analytics</li>
                            <li>� Controlled permissions and audit trails</li>
                            <li>� Commenting and revision history</li>
                        </ul>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6 hover:shadow-md transition">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <BarChart3 className="w-5 h-5" />
                            <h3 className="font-semibold">Psychometric Reporting</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� Item difficulty & discrimination stats</li>
                            <li>� Reliability analysis (KR-20, alpha)</li>
                            <li>� Standard-setting support (Angoff, Bookmark)</li>
                        </ul>
                    </div>
                </section>

                <div className="mt-10 flex flex-wrap justify-center gap-4">
                    <Link
                        to="/contact"
                        className="inline-flex items-center justify-center bg-indigo-600 text-white px-5 py-2.5 rounded-full font-semibold hover:bg-indigo-700 transition shadow-sm"
                    >
                        Contact Our Team
                    </Link>

                    <Link
                        to="/solutions/examspro"
                        className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 hover:bg-indigo-200 px-5 py-2.5 rounded-full font-semibold transition shadow-sm"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Back to ExamsPro
                    </Link>
                </div>
            </div>
        </main>
    );
}
